export const LOAD_EQUIPMENT_MODELS = "[EQUIPMENT_MODEL] LOAD_EQUIPMENT_MODELS";
export const LOAD_EQUIPMENT_SIGNEE = "[SIGNEE] LOAD_EQUIPMENT_SIGNEE";
